import moment from 'moment';
import * as fabric from 'office-ui-fabric-react';
import { DatePicker, DayOfWeek, IDatePickerStrings } from 'office-ui-fabric-react/lib/DatePicker';
import React, { FC, useEffect, useState } from 'react';
import * as api from '../../api/generated';
import '../../styles/registration.scss';
import { ShowRegistrationTicketModal } from './ShowRegistrationTicketModal';

interface ITerminalServicesProps {
    id: number;
    name: string | null;
    terminalServiceId: number;
}

interface ICreatedRegistrationTicketProps {
    serviceNumber: string | null;
    serviceName: string | null;
    registrationTime: moment.Moment;
}

interface IDateProps {
    date: moment.Moment;
}
const RegistrationPage: FC = () => {
    const [services, setServices] = useState<ITerminalServicesProps[] | null>(null);
    const [createdTicket, setCreatedTicket] = useState<ICreatedRegistrationTicketProps>();

    const [selectedService, setSelectedService] = useState({} as any);
    const [selectedDate, setSelectedDate] = useState<moment.Moment | undefined>();
    const [selectedTime, setSelectedTime] = useState('');

    useEffect(() => {
        const loadServices = async () => {
            const serv = await api.registration.getServicesByTerminal();
            setServices(serv);
        };
        loadServices();
    }, []);

    const MapOptions = (services: ITerminalServicesProps[]) => {
        return services.map(x => {
            return { key: x.id, text: x.name!, terminalServiceId: x.terminalServiceId };
        });
    };

    const createTicket = async () => {
        const timeSplitted = selectedTime!.split(':');
        if (selectedDate) {
            selectedDate.hour(parseInt(timeSplitted[0]));
            selectedDate.minutes(parseInt(timeSplitted[1]));

            const Ticket = await api.registration.createTicketRegistration({
                terminalServiceId: selectedService!.terminalServiceId,
                registrationTime: selectedDate
            });
            if (Ticket) {
                setCreatedTicket(Ticket);
            }
        }
    };

    const DayPickerStrings: IDatePickerStrings = {
        months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],

        shortMonths: ['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rug', 'Rug', 'Spa', 'Lap', 'Gru'],

        days: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],

        shortDays: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],

        goToToday: 'Eiti į šiandien',
        prevMonthAriaLabel: 'Eiti į praėjusį mėnesį',
        nextMonthAriaLabel: 'Eiti į šį mėnesį',
        prevYearAriaLabel: 'Eiti į praėjusius metus',
        nextYearAriaLabel: 'Eiti į sekančius metus',
        closeButtonAriaLabel: 'Uždaryti'
    };

    return (
        <div className="registrationScreenContainer">
            <div className="registrationFormContainer">
                <div className="mainLabel">
                    <div className="mainLabelText">Paslaugos rezervacija registratūroje</div>
                </div>
                <hr />
                {!services && <div>loading...</div>}
                {services && (
                    <fabric.Stack.Item align="center" styles={{ root: { margin: '3vw' } }}>
                        <fabric.Stack horizontal verticalAlign="center" styles={{ root: { margin: '1vw' } }}>
                            <fabric.Text styles={{ root: { marginRight: '1vw' } }}>Pasirinkite paslaugą</fabric.Text>

                            <fabric.Dropdown
                                placeholder="Pasirinkite paslaugą"
                                options={MapOptions(services)}
                                onChange={(e, item) => {
                                    setSelectedService(item);
                                }}
                                styles={{
                                    root: {
                                        justifyContent: 'center',
                                        maxWidth: 400
                                    }
                                }}
                            />
                        </fabric.Stack>

                        <fabric.Stack horizontal verticalAlign="center" styles={{ root: { margin: '1vw' } }}>
                            <fabric.Text styles={{ root: { marginRight: '1vw' } }}>Pasirinkite datą</fabric.Text>
                            <DatePicker
                                placeholder="Pasirinkite datą..."
                                onSelectDate={date => setSelectedDate(moment(date!.toString()))}
                                value={selectedDate && selectedDate!.toDate()}
                                isMonthPickerVisible={false}
                                strings={DayPickerStrings}
                                firstDayOfWeek={DayOfWeek.Monday}
                            />
                        </fabric.Stack>

                        <fabric.Stack horizontal verticalAlign="center" styles={{ root: { margin: '1vw' } }}>
                            <fabric.Text styles={{ root: { marginRight: '1vw' } }}>Pasirinkite laiką</fabric.Text>
                            <fabric.TextField
                                type="time"
                                onChange={({}, time: any) => setSelectedTime(time)}
                            />
                        </fabric.Stack>

                        <fabric.Stack.Item styles={{ root: { margin: '1vw' } }}>
                            <fabric.DefaultButton
                                styles={{
                                    root: {
                                        marginRight: '1vw',
                                        backgroundColor: '#ebad1c',
                                        minWidth: '10 vw',
                                        borderRadius: '30%'
                                    }
                                }}
                                onClick={() => createTicket()}
                            >
                                Rezervuoti
                            </fabric.DefaultButton>
                        </fabric.Stack.Item>
                    </fabric.Stack.Item>
                )}
                {createdTicket && (
                    <ShowRegistrationTicketModal
                        serviceNumber={createdTicket.serviceNumber}
                        serviceName={createdTicket.serviceName}
                        registrationTime={createdTicket.registrationTime}
                    ></ShowRegistrationTicketModal>
                )}
            </div>
        </div>
    );
};

export default RegistrationPage;
